import React from 'react';
import './DataLoader.scss';

const DataLoader = () => {
    return (
        <div className="alignLoader">
            <div className="loader"></div>
        </div>
    );
};

export default DataLoader;
